import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { TNavigationTreeNode } from '../redux-store/navigation/navigation.models';
import { NavigationFacade } from '../redux-store/navigation/navigation.facade';
import { catchError, map } from 'rxjs/operators';
import { AppNotificationUtilClass, UnifiedLoginService } from '@monorepo/services';
import { MOBILE_SCREEN_UTILS } from '@monorepo/ui';
import { MOBILE_NODES } from '../constants/navigation-tree-list';

const MOBILE_LANDING_URL = 'ticket-management/summary';
const WEB_LANDING_URL = 'factories/list';
/**
 * #deprecated
 * In Angular 16+, CanActivate, CanDeactivate, etc. are technically deprecated, but they still work just fine.
 * will move to functional guards in angular 18 migration
 */
@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  isMobileScreen = false;
  constructor(
    private navigationInfoFacade: NavigationFacade,
    private router: Router,
    private APIHelper: AppNotificationUtilClass,
    private unifiedLoginService: UnifiedLoginService,
  ) {
    this.isMobileScreen = MOBILE_SCREEN_UTILS.isMobileScreen();
  }

  //use canActivate only for navigation tree routes
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const navigationPromise = this.navigationInfoFacade.getNavigationInfoByFeature().pipe(
      map(({ navigationTreeList }) => {
        const routePath = route.routeConfig?.path;
        if (routePath) {
          this.#setSelectedNavigationItem(navigationTreeList, routePath);
        } else this.#redirectToLanding();
        return true;
      }),
      catchError((err) => {
        console.log('Error', err);
        return of(true);
      }),
    );
    return navigationPromise;
  }

  #redirectToLanding(isMobileRedirect?: boolean) {
    const landingSection = this.isMobileScreen ? MOBILE_LANDING_URL : WEB_LANDING_URL;
    this.router.navigate([landingSection]);
    if (!isMobileRedirect) this.APIHelper.presentToast('Access Denied', 'Returning to homepage');
  }

  #setSelectedNavigationItem(navigationTreeList: TNavigationTreeNode[], currentPath: string) {
    const node = this.#seachNavigationTreeNode(navigationTreeList, currentPath);
    const mobileNodes: TNavigationTreeNode['id'][] = MOBILE_NODES;
    if (node) {
      if (this.isMobileScreen && !mobileNodes.includes(node.id)) {
        this.#redirectToLanding(true);
      } else {
        this.navigationInfoFacade.resetCustomPageHeader();
        this.navigationInfoFacade.selectNavigationItem(node);
      }
    } else this.#redirectToLanding();
  }

  #seachNavigationTreeNode(nodeList: TNavigationTreeNode[], path: string): TNavigationTreeNode | null {
    for (const node of nodeList) {
      if (node?.url[0]?.includes('/' + path)) {
        return node;
      } else if (node.children?.length) {
        const found = this.#seachNavigationTreeNode(node.children, path);
        if (found !== null) {
          return found;
        }
      }
    }
    return null;
  }
}
